const Loader = () => {
    return (
        <div className="loading-overlay">
            <div className="spinner">
            </div>
        </div>
    )
}

export default Loader;